/**
 * Snapshot schedules API wrapper (#679; renamed from alertsAPI in #875)
 *
 * - listMine() is intentionally cross-group via apiGlobal so the side panel can
 *   show all of the caller's snapshots regardless of the active group context.
 * - create/update/delete are scoped per group via the standard api client.
 *
 * Note: the path-param + response field still use snapshotScheduleId until the
 * table/attr rename (#876).
 */

import { api, apiGlobal } from './api';

export const snapshotsAPI = {
  listMine: () => apiGlobal.get('/users/me/snapshots'),
  create: (groupId, body) => api.post(groupId, '/snapshots', body),
  update: (groupId, snapshotScheduleId, body) =>
    api.put(groupId, `/snapshots/${encodeURIComponent(snapshotScheduleId)}`, body),
  remove: (groupId, snapshotScheduleId) =>
    api.delete(groupId, `/snapshots/${encodeURIComponent(snapshotScheduleId)}`)
};

export default snapshotsAPI;
